import { cx } from '@linaria/core';
import { inputGroupWrapperCls, circleCls, labelCls } from './atom.gender-input.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const GenderInput = ({
  activeGender,
  onGenderChange
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: inputGroupWrapperCls,
    children: [/*#__PURE__*/jsx(Input, {
      gender: "female",
      label: "Kvinde",
      onChange: onGenderChange,
      activeGender: activeGender
    }), /*#__PURE__*/jsx(Input, {
      gender: "male",
      label: "Mand",
      onChange: onGenderChange,
      activeGender: activeGender
    })]
  });
};
const Input = ({
  gender,
  label,
  activeGender,
  onChange
}) => {
  const id = `SpeedInput-${label}`;
  const checked = gender === activeGender;
  const onToggled = () => {
    onChange(gender);
  };
  return /*#__PURE__*/jsxs("label", {
    htmlFor: id,
    className: cx(labelCls, checked && "checked"),
    children: [/*#__PURE__*/jsx("div", {
      className: circleCls,
      children: /*#__PURE__*/jsx("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onToggled
      })
    }), label]
  });
};

export { GenderInput };
//# sourceMappingURL=atom.gender-input.js.map
